export const FETCH_START_LOADING = 'FETCH_START_LOADING';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';